import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  news: [],
  loading: false,
  error: null,
  search_news: '',
};

const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    setNews: (state, action) => {
      const payloadTabs = Array.isArray(action.payload) ? action.payload : [];
      const aggregatedNews = [];

      for (const tab of payloadTabs) {
        const publications = Array.isArray(tab?.publications) ? tab.publications : [];

        // Создаем массив для подсчета позиций в этом разделе
        let sectionPosition = 0;

        for (const publication of publications) {
          const tagsString =
            typeof publication?.publication_settings === 'string'
              ? publication.publication_settings
              : '';
          if (!tagsString) continue;

          // Пытаемся преобразовать tagsString в объект
          let tagsObject = null;
          try {
            tagsObject = JSON.parse(tagsString);
          } catch (e) {
          }

          const tags = tagsString
            .split(',')
            .map((tag) => (typeof tag === 'string' ? tag.trim().toLowerCase() : ''))
            .filter(Boolean);

          // Проверяем оба условия: строку и объект
          const isNewsByString = tags.includes('news');
          const isNewsByObject = tagsObject && tagsObject.it_is_news === 'news';

          if (isNewsByString || isNewsByObject) {
            // Увеличиваем позицию в разделе для каждой новости
            sectionPosition++;

            // Добавляем информацию о родительской вкладке и позиции в разделе
            const newsItem = {
              ...publication,
              parent_tab: tab.eng_name,
              parent_tab_show_name: tab.show_name,
              section_position: sectionPosition,
            };
            aggregatedNews.push(newsItem);
          }
        }
      }

      // Фильтруем только элементы с валидной датой публикации
      const newsWithValidDate = aggregatedNews.filter((publication) => {
        const raw = publication?.publication_date;
        if (typeof raw !== 'string' || raw.trim() === '') return false;
        const time = new Date(raw).getTime();
        return Number.isFinite(time);
      });

      // Сортируем по дате публикации (сначала новые)
      newsWithValidDate.sort((a, b) => new Date(b.publication_date) - new Date(a.publication_date));

      state.news = newsWithValidDate;
      state.loading = false;
      state.error = null;
    },
    setNewsLoading: (state, action) => {
      state.loading = action.payload;
    },
    setNewsError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearNews: (state) => {
      state.news = [];
      state.loading = false;
      state.error = null;
    },
    setSearchNews: (state, action) => {
      state.search_news = action.payload;
    },
  },
});

export const { setNews, setNewsLoading, setNewsError, clearNews, setSearchNews } =
  newsSlice.actions;
export default newsSlice.reducer;
